<template>
  <div class="flex p-5">
    <Avatar v-bind:customer="customer.attributes" />
    <div class="flex-grow pl-2">
      <h2 class="font-bold text-lg">{{customer.attributes.name}}</h2>
      <div v-if="customerConversations" class="font-bold mt-2">
        <span v-if="source">{{ $t('customers.conversationsToMove') }}:</span>
        <span v-else>{{ $t('customers.conversationsExisting') }}:</span>
      </div>
      <ul v-for="conversation of customerConversations" v-bind:key="conversation.id" class="list-disc pl-5">
        <li>
          <em>{{ conversation.latest_message.text }}</em>, {{ $t('customers.status') }}: {{conversation.status}};
          <Datetime v-bind:date="conversation.created_at" />
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import Avatar from '../conversations/parts/AvatarWidget.vue'
import Datetime from '../building_blocks/DateTime.vue'

export default {
  name: 'CustomerPreview',
  props: ['customer', 'source'],
  components: {
    Avatar,
    Datetime,
  },
  computed: {
    customerConversations() {
      return [this.$root.conversationsStore.getCustomerConversations(this.customer.id)];
    },
  },
}
</script>
